/**
 * Echo permission catalogue v2 - GENERATED FILE, DO NOT EDIT.
 *
 * Source: Scripts/echo-permission-catalogue/catalogue.v2.json
 * Regenerate with: python3 Scripts/echo-permission-catalogue/generate_fe_catalogue.py
 *
 * PERMISSION mirrors ACTIONS one for one, so a call site changes only which table it
 * reads. PAGE_PERMISSION covers the keys of PREMISSIONS_BY_ROLE_BASE, and
 * CONSULTATION_PERMISSION the Permissions.* constants that are still referenced.
 */

export const PERMISSION = {
  appointment: {
    DAY_VIEW: "EchoAppointment.DayView",
    EDIT_ALL_APPOINTMENTS: "EchoAppointment.AllAppointmentsEdit",
    EDIT_ALL_BLOCKED_SLOTS: "EchoAppointment.AllBlockedSlotsEdit",
    EDIT_MY_APPOINTMENTS: "EchoAppointment.MyAppointmentsEdit",
    EDIT_MY_BLOCKED_SLOTS: "EchoAppointment.MyBlockedSlotsEdit",
    MONTH_VIEW: "EchoAppointment.MonthView",
    PROVIDER_VIEW: "EchoAppointment.ProviderView",
    ROOM_VIEW: "EchoAppointment.RoomView",
    SELECT_DOCTOR: "EchoAppointment.DoctorSelect",
    VIEW_ALL_APPOINTMENTS: "EchoAppointment.AllAppointmentsView",
    VIEW_ALL_BLOCKED_SLOTS: "EchoAppointment.AllBlockedSlotsView",
    VIEW_MY_APPOINTMENTS: "EchoAppointment.MyAppointmentsView",
    VIEW_MY_BLOCKED_SLOTS: "EchoAppointment.MyBlockedSlotsView",
    WEEK_VIEW: "EchoAppointment.WeekView",
  },
  chargeCodeV2: {
    READ_WRITE: "EchoChargeCode.ReadWrite",
    SET_ACTIVE: "EchoChargeCode.ActiveToggle",
  },
  inventory: {
    CREATE_ADJUSTMENT: "EchoInventory.AdjustmentCreate",
    CREATE_DELIVERY_ORDER: "EchoDeliveryOrder.Create",
    CREATE_DISPENSING_ORDER: "EchoDispensingOrder.Create",
    CREATE_INVENTORY: "EchoInventory.Create",
    CREATE_SUPPLIER: "EchoSupplier.Create",
    DEACTIVATE_SUPPLIER: "EchoSupplier.Deactivate",
    DELETE_DELIVERY_ORDER: "EchoDeliveryOrder.Delete",
    DELETE_DISPENSING_ORDER: "EchoDispensingOrder.Delete",
    DELETE_INVENTORY: "EchoInventory.Delete",
    EDIT_DELIVERY_ORDER: "EchoDeliveryOrder.Edit",
    EDIT_DISPENSING_ORDER: "EchoDispensingOrder.Edit",
    EDIT_INVENTORY: "EchoInventory.Edit",
    EDIT_SUPPLIER: "EchoSupplier.Edit",
    FINALIZE_EDIT_DELIVERY_ORDER: "EchoDeliveryOrder.FinalizeEdit",
    FINALIZE_EDIT_DISPENSING_ORDER: "EchoDispensingOrder.FinalizeEdit",
    REACTIVATE_SUPPLIER: "EchoSupplier.Reactivate",
    VIEW_ADJUSTMENT: "EchoInventory.AdjustmentView",
  },
  invoice: {
    CLOSE_INVOICE: "EchoInvoice.Close",
    CREATE_CREDIT_NOTE: "EchoInvoice.CreditNoteCreate",
    DELETE_DISPENSE_ITEM: "EchoInvoice.DispenseItemDelete",
    EDIT_PAYMENT: "EchoPayment.Edit",
    ITEM_DISCOUNT_EDIT: "EchoInvoice.ItemDiscountEdit",
    NOTES_EDIT: "EchoInvoice.NoteEdit",
    NOTES_VIEW: "EchoInvoice.NoteView",
    PAYMENT_INVOICE: "EchoPayment.Create",
    PRINT_CREDIT_NOTE: "EchoInvoice.CreditNotePrint",
    PRINT_INVOICE: "EchoInvoice.Print",
    PROCESS_REFUND: "EchoPayment.RefundProcess",
    UNIT_PRICE_EDIT: "EchoInvoice.UnitPriceEdit",
    VIEW_CREDIT_NOTE_LIST: "EchoInvoice.CreditNoteList",
    VIEW_INVOICE_LIST: "EchoInvoice.List",
    VOID_PAYMENT: "EchoPayment.Void",
  },
  medicalCoverage: {
    ADD_DEPOSIT: "EchoCoverage.DepositAdd",
    GENERATE_CORPORATE_INVOICE: "EchoCoverage.CorporateInvoiceGenerate",
    PRINT_CORPORATE_INVOICE: "EchoCoverage.CorporateInvoicePrint",
    RECORD_GENERATE_UPLOAD_CPF_FILE: "EchoCoverage.CpfFileUpload",
    VIEW_LIST: "EchoCoverage.List",
  },
  patient: {
    ADD_TO_QUEUE: "EchoPatient.QueueAdd",
    CREATE: "EchoPatient.Create",
    DEACTIVATE: "EchoPatient.Deactivate",
    EDIT: "EchoPatient.Edit",
    EDIT_ALLERGIES: "EchoPatient.AllergiesEdit",
    MERGE_PATIENTS: "EchoPatient.Merge",
    PRINT_IN_LIST: "EchoPatient.ListPrint",
    PRINT_LABEL: "EchoPatient.LabelPrint",
    UPDATE_COVERAGE_PAGE: "EchoPatient.CoveragePageUpdate",
    VERIFY_ALLERGIES: "EchoPatient.AllergiesVerify",
    VIEW_DASHBOARD: "EchoPatient.DashboardView",
    VIEW_DOCUMENT_TAB: "EchoPatient.DocumentTabView",
    VIEW_INFO_PREVIEW: "EchoPatient.InfoPreviewView",
    VIEW_INVESTIGATION_TAB: "EchoPatient.InvestigationTabView",
    VIEW_LIST: "EchoPatient.List",
  },
  queue: {
    CALL_QUEUE: "EchoQueue.Call",
    CANCEL_VISIT: "EchoQueue.VisitCancel",
    EDIT_NOTES: "EchoQueue.NotesEdit",
    LINK_APPOINTMENT: "EchoQueue.AppointmentLink",
    PRINT_MAILING_LABEL: "EchoQueue.MailingLabelPrint",
    PRINT_MEDICATION_LABEL: "EchoQueue.MedicationLabelPrint",
    PRINT_PATIENT_LABEL: "EchoQueue.PatientLabelPrint",
    UPDATE_PROVIDER: "EchoQueue.ProviderUpdate",
    UPDATE_VISIT_TYPE: "EchoQueue.VisitTypeUpdate",
  },
  services: {
    MEDICAL_SERVICES_CREATE: "EchoServices.MedicalServicesCreate",
    MEDICAL_SERVICES_EDIT: "EchoServices.MedicalServicesEdit",
    PACKAGE_CREATE: "EchoPackage.Create",
    PACKAGE_EDIT: "EchoPackage.Edit",
  },
  settings: {
    CLINIC_ROOM_CREATE_EDIT: "EchoSettings.ClinicRoomCreateEdit",
    CREATE_EDIT_MEDICAL_TEMPLATE: "EchoSettings.MedicalTemplateCreateEdit",
    DISCHARGE_ADVICE_CREATE: "EchoSettings.DischargeAdviceCreate",
    DISCHARGE_ADVICE_DELETE: "EchoSettings.DischargeAdviceDelete",
    DISCHARGE_ADVICE_EDIT: "EchoSettings.DischargeAdviceEdit",
    ROLE_GROUP_CREATE_ROLE: "Role.Create",
    USER_MANAGEMENT_CREATE: "User.Create",
    USER_MANAGEMENT_EDIT: "User.Update",
    USER_MANAGEMENT_RESET_PASSWORD: "User.ResetPassword",
  },
} as const;

export const PAGE_PERMISSION: Record<string, string> = {
  "Consultation.AddCharting": "EchoConsultation.ChartingAdd",
  "Consultation.DeleteAssessmentPlan": "EchoConsultation.AssessmentPlanDelete",
  "Consultation.DeleteNursingNotes": "EchoConsultation.NursingNotesDelete",
  "Consultation.DeleteVitalSign": "EchoConsultation.VitalSignDelete",
  "Consultation.DispensingPanel.FullEdit": "EchoConsultation.DispensingPanelFullEdit",
  "Consultation.DownloadNotePdf": "EchoConsultation.NotePdfDownload",
  "Consultation.DownloadNotePdfNurse": "EchoConsultation.NotePdfDownloadNurse",
  "Consultation.EditAssessmentPlan": "EchoConsultation.AssessmentPlanEdit",
  "Consultation.EditDiagnosis": "EchoConsultation.DiagnosisEdit",
  "Consultation.EditDispense": "EchoConsultation.DispenseEdit",
  "Consultation.EditDispenseBatchExpire": "EchoConsultation.DispenseBatchExpireEdit",
  "Consultation.EditDispenseComment": "EchoConsultation.DispenseCommentEdit",
  "Consultation.EditDispenseDosage": "EchoConsultation.DispenseDosageEdit",
  "Consultation.EditDispenseItemPrice": "EchoConsultation.DispenseItemPriceEdit",
  "Consultation.EditDispenseQuantity": "EchoConsultation.DispenseQuantityEdit",
  "Consultation.EditItemPrice": "EchoConsultation.ItemPriceEdit",
  "Consultation.EditLettersMCs": "EchoConsultation.LettersMCsEdit",
  "Consultation.EditNursingNotes": "EchoConsultation.NursingNotesEdit",
  "Consultation.EditPastMedication": "EchoConsultation.PastMedicationEdit",
  "Consultation.EditVitalSign": "EchoConsultation.VitalSignEdit",
  "Consultation.FormHeader.BookAppointment": "EchoConsultation.FormHeaderAppointmentBook",
  "Consultation.FormHeader.CancelVisit": "EchoConsultation.FormHeaderVisitCancel",
  "Consultation.FormHeader.CreateInternalNote": "EchoConsultation.FormHeaderInternalNoteCreate",
  "Consultation.FormHeader.CreateTask": "EchoConsultation.FormHeaderTaskCreate",
  "Consultation.FormHeader.PrintMedicationLabel": "EchoConsultation.FormHeaderMedicationLabelPrint",
  "Consultation.FormHeader.Publish": "EchoConsultation.FormHeaderPublish",
  "Consultation.FormHeader.RevertPublish": "EchoConsultation.FormHeaderRevertPublish",
  "Consultation.FormHeader.SaveDraft": "EchoConsultation.FormHeaderDraftSave",
  "Consultation.FormHeader.TransferPatient": "EchoConsultation.FormHeaderPatientTransfer",
  "Consultation.LettersMCsPanel.Create": "EchoConsultation.LettersMCsPanelCreate",
  "Consultation.LettersMCsPanel.Delete": "EchoConsultation.LettersMCsPanelDelete",
  "Consultation.LettersMCsPanel.Edit": "EchoConsultation.LettersMCsPanelEdit",
  "Consultation.PrintNote": "EchoConsultation.NotePrint",
  "Consultation.PrintNoteNurse": "EchoConsultation.NotePrintNurse",
  "Consultation.SelectConsultationTemplate": "EchoConsultation.TemplateSelect",
  "Consultation.SelectNursingTemplate": "EchoConsultation.NursingTemplateSelect",
  "Consultation.UploadFilesImages": "EchoConsultation.FilesImagesUpload",
  "Consultation.UploadFilesImagesNurse": "EchoConsultation.FilesImagesUploadNurse",
  "Consultation.ViewCharting": "EchoConsultation.ChartingView",
  "Consultation.ViewDiagnosis": "EchoConsultation.DiagnosisView",
  "Consultation.ViewPage": "EchoConsultation.ViewPage",
  "Consultation.ViewPrintLettersMCs": "EchoConsultation.LettersMCsViewPrint",
  "Dashboard.FormHeader.BookAppointment": "EchoConsultation.DashboardFormHeaderAppointmentBook",
  "Dashboard.FormHeader.CancelVisit": "EchoConsultation.DashboardFormHeaderVisitCancel",
  "Dashboard.FormHeader.CreateInternalNote":
    "EchoConsultation.DashboardFormHeaderInternalNoteCreate",
  "Dashboard.FormHeader.CreateTask": "EchoConsultation.DashboardFormHeaderTaskCreate",
  "Dashboard.FormHeader.PrintMedicationLabel":
    "EchoConsultation.DashboardFormHeaderMedicationLabelPrint",
  "Dashboard.FormHeader.Publish": "EchoConsultation.DashboardFormHeaderPublish",
  "Dashboard.FormHeader.RevertPublish": "EchoConsultation.DashboardFormHeaderRevertPublish",
  "Dashboard.FormHeader.SaveDraft": "EchoConsultation.DashboardFormHeaderDraftSave",
  "Dashboard.FormHeader.TransferPatient": "EchoConsultation.DashboardFormHeaderPatientTransfer",
  "Dispensing.DispensingPanel.FullEdit": "EchoDispensing.DispensingPanelFullEdit",
  "Dispensing.FormHeader.BookAppointment": "EchoDispensing.FormHeaderAppointmentBook",
  "Dispensing.FormHeader.CancelVisit": "EchoDispensing.FormHeaderVisitCancel",
  "Dispensing.FormHeader.CreateInternalNote": "EchoDispensing.FormHeaderInternalNoteCreate",
  "Dispensing.FormHeader.CreateTask": "EchoDispensing.FormHeaderTaskCreate",
  "Dispensing.FormHeader.PrintMedicationLabel": "EchoDispensing.FormHeaderMedicationLabelPrint",
  "Dispensing.FormHeader.Publish": "EchoDispensing.FormHeaderPublish",
  "Dispensing.FormHeader.RevertPublish": "EchoDispensing.FormHeaderRevertPublish",
  "Dispensing.FormHeader.SaveDraft": "EchoDispensing.FormHeaderDraftSave",
  "Dispensing.FormHeader.TransferPatient": "EchoDispensing.FormHeaderPatientTransfer",
  "Dispensing.LettersMCsPanel.Create": "EchoDispensing.LettersMCsPanelCreate",
  "Dispensing.LettersMCsPanel.Delete": "EchoDispensing.LettersMCsPanelDelete",
  "Dispensing.LettersMCsPanel.Edit": "EchoDispensing.LettersMCsPanelEdit",
  "Dispensing.LettersMCsPanel.ViewPrint": "EchoDispensing.LettersMCsPanelViewPrint",
  appointment: "EchoAppointment.ViewPage",
  "appointments-setup": "EchoSettings.AppointmentsSetupViewPage",
  billing: "EchoSettings.BillingViewPage",
  "billing-payment-method": "EchoSettings.BillingPaymentMethodViewPage",
  "category-setup": "EchoSettings.CategorySetupViewPage",
  "charge-code-v2": "EchoChargeCode.ViewPage",
  "clinic-services": "EchoSettings.ClinicServicesViewPage",
  "clinic-services-clinic": "EchoSettings.ClinicServicesClinicViewPage",
  "clinic-services-clinic-room": "EchoSettings.ClinicServicesClinicRoomViewPage",
  "clinic-services-vendor": "EchoSettings.ClinicServicesVendorViewPage",
  "coverage-page-update": "EchoCoverage.Edit",
  "credit-note-list": "EchoInvoice.CreditNoteViewPage",
  "delivery-order-create": "EchoDeliveryOrder.Create",
  "delivery-order-edit": "EchoDeliveryOrder.Edit",
  "delivery-order-list": "EchoDeliveryOrder.ViewPage",
  "dispensing-order-create": "EchoDispensingOrder.Create",
  "dispensing-order-list": "EchoDispensingOrder.ViewPage",
  "erp-consumption-view": "EchoErp.ConsumptionViewPage",
  general: "EchoSettings.GeneralViewPage",
  "general-category-general": "EchoSettings.GeneralCategoryGeneralViewPage",
  "general-document-category": "EchoSettings.GeneralDocumentCategoryViewPage",
  inventory: "EchoSettings.InventoryViewPage",
  "inventory-adjustment": "EchoInventory.AdjustmentViewPage",
  "inventory-adjustment-create": "EchoInventory.AdjustmentCreate",
  "inventory-adjustment-detail": "EchoInventory.AdjustmentDetailViewPage",
  "inventory-create": "EchoInventory.Create",
  "inventory-delete": "EchoInventory.Delete",
  "inventory-drug-classification": "EchoSettings.InventoryDrugClassificationViewPage",
  "inventory-edit": "EchoInventory.Edit",
  "inventory-view": "EchoInventory.ViewPage",
  "invoice-view-list": "EchoInvoice.ViewPage",
  "medical-services": "EchoServices.MedicalServicesViewPage",
  "medical-services-create": "EchoServices.MedicalServicesCreate",
  "medical-services-edit": "EchoServices.MedicalServicesEdit",
  "medical-template": "EchoSettings.MedicalTemplateViewPage",
  "medical-template-create": "EchoSettings.MedicalTemplateCreate",
  "medical-template-edit": "EchoSettings.MedicalTemplateEdit",
  "medispan-clinic-setup": "EchoSettings.MedispanClinicSetupViewPage",
  package: "EchoPackage.ViewPage",
  "package-create": "EchoPackage.Create",
  "package-edit": "EchoPackage.Edit",
  patient: "EchoPatient.ViewPage",
  "patient-registration-edit": "EchoPatient.RegistrationEdit",
  "patient-visit": "EchoSettings.PatientVisitViewPage",
  "patient-visit-backdate-visit": "EchoSettings.PatientVisitBackdateVisitViewPage",
  "patient-visit-patient-allergies": "EchoSettings.PatientVisitPatientAllergiesViewPage",
  "patient-visit-type-management": "EchoSettings.PatientVisitTypeViewPage",
  "patient-visit-vital-sign": "EchoSettings.PatientVisitVitalSignViewPage",
  pharmacy: "EchoPharmacy.ViewPage",
  "queue-view-list": "EchoQueue.ViewPage",
  "rad-lab-management": "EchoRadLab.ViewPage",
  "role-management": "RoleRoleGroup.View",
  "role-management-create": "Role.Create",
  services: "EchoServices.ViewPage",
  settings: "EchoSettings.ViewPage",
  "supplier-create": "EchoSupplier.Create",
  "supplier-edit": "EchoSupplier.Edit",
  "supplier-view": "EchoSupplier.ViewPage",
  "system-preferences": "EchoSettings.SystemPreferencesViewPage",
  "user-management": "UserListing.View",
  "user-management-create": "User.Create",
  "user-management-edit": "User.Update",
};

export const CONSULTATION_PERMISSION = {
  Consultation: {
    ADD_CHARTING: "EchoConsultation.ChartingAdd",
    DELETE_ASSESSMENT_PLAN: "EchoConsultation.AssessmentPlanDelete",
    DELETE_NURSING_NOTES: "EchoConsultation.NursingNotesDelete",
    DELETE_VITAL_SIGN: "EchoConsultation.VitalSignDelete",
    DISPENSING_PANEL_FULL_EDIT: "EchoConsultation.DispensingPanelFullEdit",
    DOWNLOAD_NOTE_PDF: "EchoConsultation.NotePdfDownload",
    DOWNLOAD_NOTE_PDF_NURSE: "EchoConsultation.NotePdfDownloadNurse",
    EDIT_ASSESSMENT_PLAN: "EchoConsultation.AssessmentPlanEdit",
    EDIT_DIAGNOSIS: "EchoConsultation.DiagnosisEdit",
    EDIT_DISPENSE: "EchoConsultation.DispenseEdit",
    EDIT_DISPENSE_BATCH_EXPIRE: "EchoConsultation.DispenseBatchExpireEdit",
    EDIT_DISPENSE_COMMENT: "EchoConsultation.DispenseCommentEdit",
    EDIT_DISPENSE_DOSAGE: "EchoConsultation.DispenseDosageEdit",
    EDIT_DISPENSE_ITEM_PRICE: "EchoConsultation.DispenseItemPriceEdit",
    EDIT_DISPENSE_QUANTITY: "EchoConsultation.DispenseQuantityEdit",
    EDIT_ITEM_PRICE: "EchoConsultation.ItemPriceEdit",
    EDIT_LETTERS_MCS: "EchoConsultation.LettersMCsEdit",
    EDIT_NURSING_NOTES: "EchoConsultation.NursingNotesEdit",
    EDIT_PAST_MEDICATION: "EchoConsultation.PastMedicationEdit",
    EDIT_VITAL_SIGN: "EchoConsultation.VitalSignEdit",
    FORM_HEADER_BOOK_APPOINTMENT: "EchoConsultation.FormHeaderAppointmentBook",
    FORM_HEADER_CANCEL_VISIT: "EchoConsultation.FormHeaderVisitCancel",
    FORM_HEADER_CREATE_INTERNAL_NOTE: "EchoConsultation.FormHeaderInternalNoteCreate",
    FORM_HEADER_CREATE_TASK: "EchoConsultation.FormHeaderTaskCreate",
    FORM_HEADER_PRINT_MEDICATION_LABEL: "EchoConsultation.FormHeaderMedicationLabelPrint",
    FORM_HEADER_PUBLISH: "EchoConsultation.FormHeaderPublish",
    FORM_HEADER_REVERT_PUBLISH: "EchoConsultation.FormHeaderRevertPublish",
    FORM_HEADER_SAVE_DRAFT: "EchoConsultation.FormHeaderDraftSave",
    FORM_HEADER_TRANSFER_PATIENT: "EchoConsultation.FormHeaderPatientTransfer",
    LETTERS_MCS_PANEL_CREATE: "EchoConsultation.LettersMCsPanelCreate",
    LETTERS_MCS_PANEL_DELETE: "EchoConsultation.LettersMCsPanelDelete",
    LETTERS_MCS_PANEL_EDIT: "EchoConsultation.LettersMCsPanelEdit",
    PRINT_NOTE: "EchoConsultation.NotePrint",
    PRINT_NOTE_NURSE: "EchoConsultation.NotePrintNurse",
    SELECT_CONSULTATION_TEMPLATE: "EchoConsultation.TemplateSelect",
    SELECT_NURSING_TEMPLATE: "EchoConsultation.NursingTemplateSelect",
    UPLOAD_FILES_IMAGES: "EchoConsultation.FilesImagesUpload",
    UPLOAD_FILES_IMAGES_NURSE: "EchoConsultation.FilesImagesUploadNurse",
    VIEW_CHARTING: "EchoConsultation.ChartingView",
    VIEW_DIAGNOSIS: "EchoConsultation.DiagnosisView",
    VIEW_PAGE: "EchoConsultation.ViewPage",
    VIEW_PRINT_LETTERS_MCS: "EchoConsultation.LettersMCsViewPrint",
  },
  Dashboard: {
    FORM_HEADER_BOOK_APPOINTMENT: "EchoConsultation.DashboardFormHeaderAppointmentBook",
    FORM_HEADER_CANCEL_VISIT: "EchoConsultation.DashboardFormHeaderVisitCancel",
    FORM_HEADER_CREATE_INTERNAL_NOTE: "EchoConsultation.DashboardFormHeaderInternalNoteCreate",
    FORM_HEADER_CREATE_TASK: "EchoConsultation.DashboardFormHeaderTaskCreate",
    FORM_HEADER_PRINT_MEDICATION_LABEL: "EchoConsultation.DashboardFormHeaderMedicationLabelPrint",
    FORM_HEADER_PUBLISH: "EchoConsultation.DashboardFormHeaderPublish",
    FORM_HEADER_REVERT_PUBLISH: "EchoConsultation.DashboardFormHeaderRevertPublish",
    FORM_HEADER_SAVE_DRAFT: "EchoConsultation.DashboardFormHeaderDraftSave",
    FORM_HEADER_TRANSFER_PATIENT: "EchoConsultation.DashboardFormHeaderPatientTransfer",
  },
  Dispensing: {
    DISPENSING_PANEL_FULL_EDIT: "EchoDispensing.DispensingPanelFullEdit",
    FORM_HEADER_BOOK_APPOINTMENT: "EchoDispensing.FormHeaderAppointmentBook",
    FORM_HEADER_CANCEL_VISIT: "EchoDispensing.FormHeaderVisitCancel",
    FORM_HEADER_CREATE_INTERNAL_NOTE: "EchoDispensing.FormHeaderInternalNoteCreate",
    FORM_HEADER_CREATE_TASK: "EchoDispensing.FormHeaderTaskCreate",
    FORM_HEADER_PRINT_MEDICATION_LABEL: "EchoDispensing.FormHeaderMedicationLabelPrint",
    FORM_HEADER_PUBLISH: "EchoDispensing.FormHeaderPublish",
    FORM_HEADER_REVERT_PUBLISH: "EchoDispensing.FormHeaderRevertPublish",
    FORM_HEADER_SAVE_DRAFT: "EchoDispensing.FormHeaderDraftSave",
    FORM_HEADER_TRANSFER_PATIENT: "EchoDispensing.FormHeaderPatientTransfer",
    LETTERS_MCS_PANEL_CREATE: "EchoDispensing.LettersMCsPanelCreate",
    LETTERS_MCS_PANEL_DELETE: "EchoDispensing.LettersMCsPanelDelete",
    LETTERS_MCS_PANEL_EDIT: "EchoDispensing.LettersMCsPanelEdit",
    LETTERS_MCS_PANEL_VIEW_PRINT: "EchoDispensing.LettersMCsPanelViewPrint",
  },
} as const;
